// A button that is waiting on the server and a button that is merely disabled
// look identical without this: both go dim, both stop responding. The
// difference matters most on the slow calls — an invitation that sends an
// email, a revoke that walks a list — because the honest reading of a dim,
// silent button is "it did not work", and the second click is what follows.
//
// The ring is drawn in `currentColor` and sized in `em`, so one component fits
// a primary button, a small danger button and a line of muted text without a
// variant for each.

/**
 * The ring itself. Decorative by default: put it in a control whose visible
 * label already changed ("Sending…") and screen readers get that label. Pass
 * `label` only when nothing else on screen says what is happening — the ×
 * button on a role chip, for instance, which has no room for a word.
 */
export function Spinner({ label }: { label?: string }) {
  return (
    <>
      <span className="spinner" aria-hidden="true" />
      {label && <span className="visually-hidden">{label}</span>}
    </>
  );
}

/**
 * Waiting for a panel's first load, in place of the content. `role="status"`
 * rather than a live region on the whole card: the arrival of the list is what
 * is worth announcing, not every row of it.
 */
export function Loading({ label }: { label: string }) {
  return (
    <p className="muted loading-row" role="status">
      <Spinner /> {label}
    </p>
  );
}
